import {
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE,
  GET_JUNIOR_HANDLING_RESULT_FILES,
  GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS,
  GET_JUNIOR_HANDLING_RESULT_FILES_FAIL,
  ADD_JUNIOR_HANDLING_EVENT_FILE,
  ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS,
  ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE,
 GET_JUNIOR_HANDLING_FILE_RESULTS,
  GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS,
  GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL,

} from "./actionTypes";

export const getJuniorHandlingFileResults= (data,token) => {
  return {
    type: GET_JUNIOR_HANDLING_FILE_RESULTS,
    payload:data,
    token:token
  };
};

export const getJuniorHandlingFileResultsSuccess = (res) => {
  return {
    type: GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS,
    payload: res,
  };
};

export const getJuniorHandlingFileResultsFail = (error) => {
  return {
    type: GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL,
    payload: error,
  };
};


export const getJuniorHandlingAttendeeResults= (data,token) => {
  return {
    type: GET_JUNIOR_EVENT_ATTENDEE_RESULTS,
    payload:data,
    token:token
  };
};

export const getJuniorHandlingAttendeeResultsSuccess = (res) => {
  return {
    type: GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS,
    payload: res,
  };
};

export const getJuniorHandlingAttendeeResultsFail = (error) => {
  return {
    type: GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL,
    payload: error,
  };
};

export const getJuniorHandlingEvents= (token) => {

  return {
    type: GET_JUNIOR_HANDLING_RESULT_FILES,
    payload:token
  };
};

export const getJuniorHandlingEventsSuccess = (eventList) => {
  return {
    type: GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS,
    payload: eventList,
  };
};

export const getJuniorHandlingEventsFail = (error) => {
  return {
    type:GET_JUNIOR_HANDLING_RESULT_FILES_FAIL,
    payload: error,
  };
};

export const addJuniorHandlingEvent = (data,navigate,token) => {
  return {
    type: ADD_JUNIOR_HANDLING_EVENT_FILE,
    payload: data,
    navigate:navigate,
    token:token
  };
};

export const addJuniorHandlingEventSuccess = (addEventResponse) => {
  return {
    type: ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS,
    payload:addEventResponse,
  };
};

export const addJuniorHandlingEventFailure = (error) => {
  return {
    type: ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE,
    payload:error,
  };
};



// delete event file


export const delJuniorHandlingEventFile = (data,navigate,token) => {
  return {
    type: DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE,
    payload: data,
    navigate:navigate,
    token:token
  };
};

export const delJuniorHandlingEventFileSuccess = (response) => {
  return {
    type: DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS,
    payload:response,
  };
};

export const delJuniorHandlingEventFileFailure = (error) => {
  return {
    type: DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE,
    payload:error,
  };
};